webpackJsonp([259],{

/***/ 1199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformEducationForm_vue__ = __webpack_require__(2911);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42a4d0eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformEducationForm_vue__ = __webpack_require__(5193);
function injectStyle (ssrContext) {
  __webpack_require__(5191)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42a4d0eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformEducationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42a4d0eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformEducationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wangeditor__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wangeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wangeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(77);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wangEditor',
  props: {
    value: {
      type: String
    },
    tag: {
      type: String,
      default: 'div'
    },
    menus: Array,
    /**
     [
     'head',  // 标题
     'bold',  // 粗体
     'italic',  // 斜体
     'underline',  // 下划线
     'strikeThrough',  // 删除线
     'foreColor',  // 文字颜色
     'backColor',  // 背景颜色
     'link',  // 插入链接
     'list',  // 列表
     'justify',  // 对齐方式
     'quote',  // 引用
     'emoticon',  // 表情
     'image',  // 插入图片
     'table',  // 表格
     'video',  // 插入视频
     'code',  // 插入代码
     'undo',  // 撤销
     'redo'  // 重复
     ]
     */
    colors: Array,
    /**
     [
     '#000000',
     '#eeece0',
     '#1c487f',
     '#4d80bf',
     '#c24f4a',
     '#8baa4a',
     '#7b5ba1',
     '#46acc8',
     '#f9963b',
     '#ffffff'
     ]
     */
    config: Object,
    zIndex: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      editor: null
    };
  },

  watch: {
    value: function value() {
      // 双向绑定，父组件同步到子组件
      if (this.value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 实例化编辑器
    // 双向绑定，子组件同步到父组件
    this.editor = new __WEBPACK_IMPORTED_MODULE_1_wangeditor___default.a(this.$el);

    this.editor.customConfig.uploadImgServer = this.uploadFilePath;
    this.editor.customConfig.uploadFileName = this.uploadFileName;
    this.editor.customConfig.uploadImgHeaders = {
      'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* getToken */])()
    };
    this.editor.customConfig.uploadImgParams = this.uploadFileParams;

    this.editor.customConfig.uploadImgHooks = {
      before: function before(xhr, editor, files) {

        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function success(xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: function fail(xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function error(xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function timeout(xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function customInsert(insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.detail.url;
        insertImg(url);
      }
    };

    this.editor.customConfig.onchange = function (html) {
      if (html !== _this.value) {
        _this.$emit('input', html);
      }
    };
    // 获得焦点事件
    this.editor.customConfig.onfocus = function () {
      _this.$emit('focus');
    };
    // 失去焦点事件
    this.editor.customConfig.onblur = function () {
      _this.$emit('blur');
    };
    // 配置数据
    this.editor.customConfig.zIndex = this.zIndex;
    if (this.menus) this.editor.customConfig.menus = this.menus;
    if (this.colors) this.editor.customConfig.colors = this.colors;
    if (this.config) this.editor.customConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.editor.customConfig, this.config);
    // 创建编辑器
    this.editor.create();
    // 赋初始值
    this.editor.txt.html(this.value);
  },
  destroyed: function destroyed() {
    // 销毁编辑器
    this.editor._offAllEvent();
  },
  render: function render(h) {
    return h(this.tag, {
      class: {},
      style: {}
    }, this.$slots.default);
  }
});

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(79);

/***/ }),

/***/ 2429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marketFormRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入教程标题', 'string'))],
  content: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入教程正文', 'string'))],
  video_url: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传教程简介', 'string'))],
  description: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入教程简介', 'string'))],
  image_url: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传封面', 'string'))],
  level: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入优先级', 'integer'))],
  badge_start: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择角标开始时间', 'string'))],
  badge_end: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择角标结束时间', 'integer'))]
};

var marketFormRules = {
  marketname: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入门店名称', 'string'))],
  address: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入地址', 'string'))],
  provinceid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择省份', 'integer'))],
  cityid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择城市', 'integer'))],
  areaid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择地区', 'integer'))],
  longitude: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入百度经度', 'number'))],
  latitude: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入百度纬度', 'number'))],
  lon_gd: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入高德经度', 'number'))],
  lat_gd: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入高德纬度', 'number'))]
};

/***/ }),

/***/ 2911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_rules_js__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WangEditorV3Deprecated__ = __webpack_require__(1593);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WangEditor: __WEBPACK_IMPORTED_MODULE_2__components_WangEditorV3Deprecated__["a" /* default */] },
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_1__platform_rules_js__["b" /* searchRules */],
      selectLoading: false,
      form: {
        id: this.$route.query.id,
        title: null,
        content: null,
        video_url: null,
        description: null,
        image_url: null,
        level: null,
        type: Number(this.$route.query.type)
      },
      uploadFilePath: null
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.uploadFilePath = window._env_.VUE_APP_ADMIN_HOST + '/helpcenter_upload_file';
    if (this.form.id !== null && this.form.id !== undefined) {
      this.onGetEducation();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['createEducation', 'editEducation', 'uploadFile', 'getEducation']), {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var data = {
            title: _this.form.title,
            content: _this.form.content,
            video_url: _this.form.video_url,
            description: _this.form.description,
            image_url: _this.form.image_url,
            level: _this.form.level,
            type: _this.$route.query.type
          };
          if (_this.form.id === null || _this.form.id === undefined) {
            return request.common('createEducation', data).then(function (data) {
              _this.$message({
                showClose: true,
                message: '保持成功',
                type: 'success'
              });
              _this.$router.push({ path: '/platform/education_table' });
            });
          } else {
            data.id = _this.form.id;
            return request.common('editEducation', data).then(function (data) {
              _this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
              _this.$router.push({ path: '/platform/education_table' });
            });
          }
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    onChangeImg: function onChangeImg(file, filelist) {
      if (file.raw.type !== 'application/x-img' && file.raw.type !== 'image/png' && file.raw.type !== 'image/jpeg') {
        this.$message.error('请上传jpg/jpeg/png图片!');
        this.$refs.uploadThumb.clearFiles();
        return false;
      }

      var isLt10M = file.raw.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var width = 688;
      var height = 340;
      var self = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        var img = new Image();
        img.src = data;
        img.onload = function () {
          if (img.width === width && img.height === height) {
            var _data = new FormData();
            _data.append('file', file.raw);
            return request.common('uploadFile', _data).then(function (res) {
              self.form.image_url = res.data;
            });
          } else {
            self.$message.error('上传图片的宽度为' + img.width + ',长度为' + img.height + ',限制尺寸宽度为' + width + ',长度为' + height + ',请重新选择图片尺寸上传');
          }
        };
      };
      reader.readAsDataURL(file.raw);
    },
    onHandleChangeViedeo: function onHandleChangeViedeo(file, filelist) {
      var _this2 = this;

      if (file.raw.type !== 'video/mp4') {
        this.$message.error('请上传mp4视频!');
        this.$refs.uploadThumb.clearFiles();
        return false;
      }
      var isLt10M = file.raw.size / 1024 / 1024 < 50;
      if (!isLt10M) {
        this.$message.error('大小不能超过20MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var data = new FormData();
      data.append('file', file.raw);
      return request.common('uploadFile', data).then(function (res) {
        _this2.form.video_url = res.data;
      });
    },
    onGetEducation: function onGetEducation() {
      var _this3 = this;

      return request.page('getEducation', this.form.id).then(function (data) {
        filter.setLoop(_this3.form, data.data);
      });
    }
  })

});

/***/ }),

/***/ 5191:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5192);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("db6acb10", content, true, {});

/***/ }),

/***/ 5192:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".avatar-uploader[data-v-42a4d0eb]{width:148px;height:148px;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-42a4d0eb]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-42a4d0eb]{font-size:28px;color:#8c939d;width:148px;height:148px;line-height:148px;text-align:center}.avatar[data-v-42a4d0eb]{width:148px;height:148px;display:block}", "", {"version":3,"sources":["/workspace/src/views/platform/pages/PlatformEducationForm.vue"],"names":[],"mappings":"AACA,kCAAkC,YAAY,aAAa,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CACtJ,AACD,mDAAmD,oBAAoB,CACtE,AACD,uCAAuC,eAAe,cAAc,YAAY,aAAa,kBAAkB,iBAAiB,CAC/H,AACD,yBAAyB,YAAY,aAAa,aAAa,CAC9D","file":"PlatformEducationForm.vue","sourcesContent":["\n.avatar-uploader[data-v-42a4d0eb]{width:148px;height:148px;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.avatar-uploader .el-upload[data-v-42a4d0eb]:hover{border-color:#409EFF\n}\n.avatar-uploader-icon[data-v-42a4d0eb]{font-size:28px;color:#8c939d;width:148px;height:148px;line-height:148px;text-align:center\n}\n.avatar[data-v-42a4d0eb]{width:148px;height:148px;display:block\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("平台管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/platform/education_table'}}},[_vm._v("教程管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",staticClass:"demo-ruleForm",attrs:{"model":_vm.form,"rules":_vm.searchRules,"label-width":"120px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-form-item',{attrs:{"prop":"title","label":"教程标题:"}},[_c('el-input',{attrs:{"maxlength":11,"placeholder":"不超过11个字"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),(_vm.form.type === 1)?_c('el-form-item',{attrs:{"prop":"content","label":"教程正文:"}},[_c('wang-editor',{attrs:{"menus":['head','bold','italic','underline','strikeThrough','foreColor','list','justify','quote','table','undo','redo','image'],"colors":['#f3605b', '#333'],"uploadFilePath":_vm.uploadFilePath,"uploadFileName":"file"},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}})],1):_vm._e(),_vm._v(" "),(_vm.form.type === 2)?_c('el-form-item',{attrs:{"prop":"video_url","label":"教程视频:"}},[_c('el-upload',{staticClass:"upload-demo",attrs:{"action":"","on-change":_vm.onHandleChangeViedeo,"show-file-list":false,"auto-upload":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传\n          ")])],1),_vm._v(" "),(_vm.form.type === 2 && _vm.form.video_url)?_c('a',{attrs:{"href":_vm.form.video_url,"target":"_blank"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("查看详情\n          ")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"description","label":"教程简介:"}},[_c('el-input',{attrs:{"maxlength":14,"placeholder":"不超过14个字"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"image_url","label":"封面:"}},[_c('el-upload',{ref:"uploadThumb",staticClass:"avatar-uploader",attrs:{"show-file-list":false,"on-change":_vm.onChangeImg,"action":"","auto-upload":false}},[(_vm.form.image_url)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.form.image_url+'?x-oss-process=image/resize,w_100/auto-orient,1'}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"level","label":"优先级:"}},[_c('el-input',{attrs:{"placeholder":"请输入优先级","type":"number"},model:{value:(_vm.form.level),callback:function ($$v) {_vm.$set(_vm.form, "level", $$v)},expression:"form.level"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("新建\n        ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/platform/education_table'}}},[_c('el-button',[_vm._v("取消")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/platform-education-form.753535ba59d0b9f43937.js